import { combineReducers } from 'redux'

import arquivosAssinadosEmpenhoCredor from './arquivosAssinadosEmpenhoCredor'

export default combineReducers({ arquivosAssinadosEmpenhoCredor })
